<greco-simple-dialog [data]="dialogData">
  <greco-series-details-page (refreshed)="close()" [series]="data.series"></greco-series-details-page>
</greco-simple-dialog>
